import axios from '@axios'

const route = 'manager_room'

const extractPrinterKey = item => {
  if (!item) return null
  if (typeof item === 'string') return item
  if (typeof item === 'object') {
    if (item.printer_key) return item.printer_key
    if (item.printerKey) return item.printerKey
    if (item.printer && item.printer.printer_key) return item.printer.printer_key
  }

  return null
}

const extractPrinterKeys = input => {
  if (!input) return []
  if (Array.isArray(input)) {
    return input.map(extractPrinterKey).filter(Boolean)
  }
  const key = extractPrinterKey(input)

  return key ? [key] : []
}

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {

    updateRoomBusy(context, room) {
      return axios.put(`${route}/update_room_busy/${room.id}`, room)
    },
    storeItemRemoved(context, itemRemoved) {
      return axios.post(`${route}/store_item_removed`, itemRemoved)
    },
    storeTransItens(context, payload) {
      return axios.post(`${route}/store_trans_itens`, payload)
    },
    storeTransItensOutstanding(context, payload) {
      return axios.post(`${route}/store_trans_itens_outstanding`, payload)
    },
    storeTransfRoom(context, transf) {
      return axios.post(`${route}/store_transf_room/${transf.accommodation_id}`, { room_id: transf.room_id, justification: transf.justification })
    },
    printProduct(context, accomodation) {
      let printerKeys = extractPrinterKeys(accomodation?.printer_keys)
      if (!printerKeys.length) {
        printerKeys = extractPrinterKeys(accomodation?.printer_key)
      }

      if (!printerKeys.length) {
        try {
          const saved = localStorage.getItem('printerSelection')
          if (saved) {
            const parsed = JSON.parse(saved)
            printerKeys = extractPrinterKeys(parsed)
          }
        } catch (e) {
          printerKeys = []
        }
      }

      if (!printerKeys.length) {
        return Promise.reject(new Error('Nenhuma impressora selecionada'))
      }

      const requests = printerKeys.map(printer_key => axios.post(`${route}/print_product/${accomodation.accommodation_id}`, {
        printer_key,
        product_id: accomodation?.product_id,
        pdv_id: accomodation?.pdv_id,
      }))

      return Promise.all(requests)
    },
    updateEditCheckout(context, data) {
      return axios.post(`${route}/update_accommodation_item/${data.accommodation_id}`, data.accommodation_item)
    },
    updateExtraTarrif(context, data) {
      return axios.post(`${route}/update_extra_item/${data.accommodation_id}`, data.extra_items)
    },
    exportAccommodationPdf(context, room) {
      return axios.get(`${route}/export_accommodation_pdf/${room.id}`, { responseType: 'blob' })
    },
    exportConsumptionPdf(context, room) {
      return axios.get(`${route}/export_consumption_pdf/${room.id}`, { responseType: 'blob' })
    },
    getAccommodationObservations(context, id) {
      return axios.get(`${route}/get_observations/${id}`)
    },
    updateObservations(context, data) {
      return axios.post(`${route}/update_observations`, data)
    },
    alertConsumptionLimit(context, data) {
      return axios.get(`${route}/alert_consumption/${data}`)
    },
    cancelCheckin(context, data) {
      return axios.post(`${route}/cancel_checkin`, data)
    },
    updateReserve(context, data) {
      return axios.post(`${route}/update_reserve_status`, data)
    },

  },
}
